import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5d42eb3c&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=true&"
export * from "./Footer.vue?vue&type=script&lang=true&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=5d42eb3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d42eb3c",
  null
  
)

export default component.exports